import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const TESTIMONIALS = [{
  quote: 'Antes sentía que cada Clase II era diferente y terminaba eligiendo el aparato por experiencia. Hoy sigo un mismo proceso diagnóstico y la decisión llega mucho más clara.',
  name: 'Mariana P.',
  country: 'Colombia 🇨🇴',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a8dcdac9-349a-434d-8f39-5a724b5a35fa.jpg'
}, {
  quote: 'El Tomo 4 cambió completamente mi forma de diagnosticar. Ahora cada caso tiene un orden lógico y puedo justificar cada decisión con seguridad.',
  name: 'Rodrigo V.',
  country: 'México 🇲🇽',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6bdf1e49-d8e3-430f-b605-7a1760f410d5.jpg'
}, {
  quote: 'Lo mejor del sistema es que no memoricé más aparatos. Aprendí cómo decidir cuál necesita realmente cada paciente.',
  name: 'Andrea L.',
  country: 'Argentina 🇦🇷',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/dae14db6-8ee3-4c73-853d-5b7b2ebb5448.jpg'
}, {
  quote: 'Después de aplicar el Tomo 3 entendí por qué algunos tratamientos nunca avanzaban. Había factores funcionales que jamás estaba evaluando.',
  name: 'Javier C.',
  country: 'Venezuela 🇻🇪',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bcca1c56-c60b-44e3-9d87-be475e846cc5.jpg'
}, {
  quote: 'Solo el bono del laboratorio me ahorró varios errores que antes repetía constantemente. Recuperé la inversión en muy poco tiempo.',
  name: 'Sofía B.',
  country: 'Chile 🇨🇱',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ff728cf2-f359-4651-96d2-4d587a179aa7.jpg'
}];
export function Testimonials() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-254" data-mp="1itqsvhoxdxtv">
      <div className="mx-auto w-full max-w-3xl" data-id="element-255" data-mp="1nn255ycib6t6">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-256" data-mp="1nnv4ie94yu1a">
          Lo que opinan los odontólogos que ya dejaron de improvisar
        </h2>

        <div className="mt-9 space-y-4" data-id="element-257" data-mp="1sh3896joxi1d">
          {TESTIMONIALS.map(t => <figure key={t.name} className="rounded-2xl border border-ofm-100 bg-white p-5 shadow-sm" data-id="element-258" data-mp="1ofhod18qo3ho">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-259" data-mp="1ejodrnekyk2j">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-260" data-mp="19rmwfn2k235n" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-[14px] leading-relaxed text-ofm-900/80 sm:text-[15px]" data-id="element-261" data-mp="10tkxdd2dtkl0">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-ofm-100 pt-4" data-id="element-262" data-mp="qtaizp4m2749">
                <img src={t.image} alt={`Retrato de ${t.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-ofm-100" loading="lazy" data-id="element-263" data-mp="32hfgzhl4gajl" />
                <div className="min-w-0" data-id="element-264" data-mp="3cfv3f797evmr">
                  <p className="truncate text-[14px] font-bold text-ofm-900" data-id="element-265" data-mp="3gh6yvtereb2v">{t.name}</p>
                  <p className="truncate text-[12px] text-ofm-800/60" data-id="element-266" data-mp="2jqo8ei8yko69">{t.country}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <CTAButton className="mt-9" label="🦷 QUIERO LOS MISMOS RESULTADOS" subline="Únete a más de 1.200 odontólogos" data-id="element-267" data-mp="2onejss9tivlc" />
      </div>
    </section>;
}